import {TableHeaderItem} from "@/views/components/YtoTable/TableHeaderItem";

const defaultWidth = 120;

const tableHeader: TableHeaderItem[] = [
  {prop: 'Index2', label: '序号', width: 60, fixed: 'left'},
  {prop: 'code', label: '实物条码', width: 200, fixed: 'left'},
  {prop: 'CarSignNum', label: '车签号', width: 200},
  {prop: 'NextWebPointName', label: '下一网点', width: defaultWidth},
  {prop: 'weight', label: '称入重', width: 80},
  {prop: 'PutinWeight', label: '输入重', width: 80},
  //{prop: 'VolumnWeight', label: '体积重', width: 60},
  {prop: 'length', label: '长', width: 80},
  {prop: 'width', label: '宽', width: 80},
  {prop: 'height', label: '高', width: 80},
  {prop:'Str9',label:'格口号', width:80},
  {prop: 'ScanTime', label: '扫描时间', width: defaultWidth * 3},
  {prop: 'UploadStateName', label: '状态', width: defaultWidth, fixed: 'right'},
  {prop: 'Info', label: '提示警告信息', width: null, fixed: 'right'},
];
const header2: TableHeaderItem[] = [
  {prop: '', label: '序号', width: defaultWidth},
  {prop: '', label: '单号', width: defaultWidth},
  {prop: '', label: '下一分拨', width: defaultWidth},
  {prop: '', label: '上一分拨', width: defaultWidth},
  {prop: '', label: '异常类型', width: defaultWidth}
];
const tableHeader2: TableHeaderItem[] = [
  {prop: 'Index2', label: '序号', width: 60, fixed: 'left'},
  {prop: 'code', label: '实物条码', width: 200, fixed: 'left'},
  {prop: 'CarSignNum', label: '车签号', width: 200},
  {prop: 'NextWebPointName', label: '下一网点', width: defaultWidth},
  {prop: 'LineName', label: '线路信息', width: defaultWidth},
  {prop: 'weight', label: '称入重', width: 80},
  {prop: 'PutinWeight', label: '输入重', width: 80},
  //{prop: 'VolumnWeight', label: '体积重', width: 60},
  {prop: 'length', label: '长', width: 80},
  {prop: 'width', label: '宽', width: 80},
  {prop: 'height', label: '高', width: 80},
  {prop:'Str9',label:'格口号', width:80},
  {prop: 'ScanTime', label: '扫描时间', width: defaultWidth * 3},
  {prop: 'UploadStateName', label: '下车状态', width: defaultWidth, fixed: 'right'},
  {prop: 'UploadStateName2', label: '上车状态', width: defaultWidth, fixed: 'right'},
  {prop: 'Info', label: '提示警告信息', width: null, fixed: 'right'},
];
export default {tableHeader, header2,tableHeader2}
